import {
  Box,
  CardMedia,
} from '@mui/material';
import MediaPlayer from '../../../media/MediaPlayer';
import TextLines from '../../../text/TextLines';
import './SequencingResponse.scss';
import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  responseCard: {},
  responseCardId: '',
  disablePlayMedia: false,
  onClick: () => {},
};

export default function SequencingResponse(p) {
  const { responseCard, responseCardId, disablePlayMedia, onClick } = { ...defaultProps, ...filterUndefined(p) };
  return (
    <Box
      id={responseCardId}
      boxShadow={2}
      className='sequencing-response-card'
      onClick={onClick}
    >
      {disablePlayMedia ? '' : (
        <MediaPlayer
          audioUrl={responseCard.audio}
          videoUrl={responseCard.video}
          parentElementId={responseCardId}
          className='response-media'
        />
      )}
      {responseCard.image ? <CardMedia image={responseCard.image} className='response-image' alt={responseCard.name} aria-label={responseCard.name || 'image'} /> : ''}

      {responseCard.text ? (
        <div className={`response-text ${responseCard.image ? 'text-with-image' : ''}`}>
          <TextLines textLines={responseCard.text} />
        </div>
      ) : ''}
    </Box>
  );
}
